var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      staticClass:
        "c-talk-navbar navbar navbar-expand-lg navbar-light bg-light",
    },
    [
      _c("div", { staticClass: "ml-auto" }, [
        _c("form", { staticClass: "form-inline" }, [
          _c("div", { staticClass: "d-flex flex-nowrap" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchInput,
                  expression: "searchInput",
                },
              ],
              staticClass: "form-control me-sm-2",
              attrs: { type: "search", placeholder: "Quick Search" },
              domProps: { value: _vm.searchInput },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.$emit("search", _vm.searchInput)
                },
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.searchInput = $event.target.value
                  },
                  function ($event) {
                    return _vm.onSearchInput()
                  },
                ],
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.$emit("search", _vm.searchInput)
                  },
                },
              },
              [_c("span", { staticClass: "fa fa-search" })]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }